import GenericCatalogPage from "./GenericCatalogPage";
import { Container } from "lucide-react";

export default function Containers() {
  return (
    <GenericCatalogPage
      title="Recipientes"
      description="Administre los recipientes para muestras"
      icon={Container}
      apiKey="containers"
      testIdPrefix="container"
    />
  );
}
